import { ManufacturerRepository } from '../data/manufacturer-repository';
import { ManufacturerItem } from '../types/manufacturer-types';

export class GetManufacturerByIdUseCase {
  constructor(private readonly repository: ManufacturerRepository) {}

  async execute(id: number): Promise<ManufacturerItem> {
    return this.repository.getById(id);
  }
}
